module.exports = __webpack_public_path__ + "static/media/short-arrow-b.6f4406a0.svg";